import * as React from 'react';
import PlanoDeAcaoModeloPersonalizado from '../PlanoDeAcaoModeloPersonalizado';
import PlanoDeAcaoModeloPadrao from '../PlanoDeAcaoModeloPadrao';
import { LanguageContext } from 'context/LanguageContext';

const PlanoAcaoFormulario = ({ resultadoPlanoAcao }) => {
  const context = React.useContext(LanguageContext);
  return (
    <div>
        <h4>Plano de ação</h4>
        {
          resultadoPlanoAcao
            .map((acao, index) => {
              const { campomodeloacaoXValor } = acao;
              const possuiAcaoPersonalizada = campomodeloacaoXValor && campomodeloacaoXValor.length > 0;

              return (
                possuiAcaoPersonalizada
                  ? <PlanoDeAcaoModeloPersonalizado
                      key={ index }
                      acao={ acao }
                    />
                  : <PlanoDeAcaoModeloPadrao
                      key={ index }
                      acao={ acao }
                    />
              )
            })
        }
    </div>
  );
};

export default PlanoAcaoFormulario;
